import { createContext } from 'react';
var RendererContext = /*#__PURE__*/createContext({
  formOptions: {}
});
export default RendererContext;